import { computed } from 'vue'
import { useFreeFormsModule } from '@/modules/free-forms'

export default function useTranslationHelper () {
    const { getTranslationDomains, translationDomains } = useFreeFormsModule()
    const getDescriptionTranslations = async () => await getTranslationDomains()

    const translationOptions = computed(() => {
        const domains = translationDomains.value.map(item => {
            return {
                value: item.domain,
                label: `${item.domain} <span class="text-status-${item.status} text-subtitle2">(status: ${item.status})</span>`
            }
        })
        return [
            ...domains,
            { value: 'create_new_domain', label: '<span class="text-weight-medium">Create new translation domain...</span>' }
        ]
    })

    return { getDescriptionTranslations, translationOptions }
}
